import UserDashboard from "../components/profile/UserDashboard";
import Styles from "../css/profile/dashboard.module.css"
const Dashboard = () => {

    return (<div id={Styles.dashboardWrapper}>
        <UserDashboard />
    </div>)
}
export default Dashboard